<script lang="ts">
   import {createEventDispatcher, getContext} from "svelte";
    import RadioBtn from "../form/RadioBtn.svelte";

   import {myStore, entityStore} from "../../stores.js";
   import CommunityDataBox from "../form/CommunityDataBox.svelte";
   import MultiSelectDropdown from "../form/MultiSelectDropdown.svelte";

   let communities = [];

   $: communities = $entityStore.allCommunities;

   const debouncedLogData = Utils.debounce(Utils.logMessageAndValue, 500);


   $: debouncedLogData("all data",$myStore.data);//  console.log("lala",$myStore.data);


    const dispatch = createEventDispatcher();

   let submitted:Boolean = false;


   export let disabledFields = true;
   let validStep = null;
   const stepKey = "step2";


 /*
   function checkValidity(key){

      const step =  $entityStore.steps.find((s) => s.key == key)
      if(step){
         return !step.valid && step.touched;
      }
      return false;

   }
*/

   // const { lala} = getContext('lala');

    /*
    function onSubmitBtnClicked(){
       dispatch('submitBtnClicked');
    }

     */
   import Select from 'svelte-select';
   import ErrorBox from "../form/ErrorBox.svelte";
   import {Utils} from "../../util";

   //console.log("lala",form.toString());
//console.log("formData123 = ", getValue(form,'pactIsSignedBySyndicate'));


   function checkValidity(key){
      let steps =  $entityStore.steps;
      const index = steps.findIndex((s) => s.key == key)
      if(steps[index]){
         validStep = steps[index].valid; // !step.valid && step.touched;

         steps[index].touched = true;

         if(validStep){
            //open next accordion
            if(index < steps.length){
               steps[index].expanded = false;
               steps[index].isActive = false;
               steps[index].disabled = false;

               steps[index+1].disabled = false;
               steps[index+1].isActive = true;
               steps[index+1].expanded = true;


            }

         }

         entityStore.update($entityStore => ({
            ...$entityStore,
            steps
         }));
      }
   }

   function validateCurrentStep(){

      console.log("validate!");
      submitted = true;
      //validateStep(stepKey);
      checkValidity(stepKey)

      console.log("steps after: ",$entityStore.steps);

      /*
      if($myStore.data.step2.pactIsSignedBySyndicate === true){

         $myStore.setData('step5.tmp_pactIsSignedBySyndicate', (val)  =>  true);

         console.log("yo true")
      }else {
         $myStore.setData('step5.tmp_pactIsSignedBySyndicate',(val) =>  false);
         console.log("yo false");
      }

       */

   }


   function communitiesSelected(event){
      const selection = event.detail.value.map(c => {
         //$myStore.addField(`communities`,c, communities.length + 1);
         return c.value;
      });

      $myStore.setData('step2.communities',selection);

      entityStore.update($entityStore => ({
         ...$entityStore,
         availableCommunities: communities.filter(c => {
            return selection.includes(c.value)
         })
         //TODO set communities validation
      }));



   }

</script>

<!-- translation example: {$_('introText')}-->
<div class="step">
<!--debug:
   communities count = {$entityStore.allCommunities.length}<br>
   selected count = {$entityStore.availableCommunities.length}
-->
   <div class="section no-border">

      <h3 class="title">Commune·s concernée·s</h3>

<MultiSelectDropdown disabled={disabledFields} error={$myStore.errors.step2?.communities != null} placeholder="Veuillez renseigner une ou plusieurs communes (Liste CA.CLR)" on:select={communitiesSelected} items={communities} title="Veuillez renseigner une ou plusieurs communes (Liste CA.CLR)"></MultiSelectDropdown>

   </div>

   <div class="section no-border">

      <h3 class="title">Le pacte sera-t-il signé et géré par un syndicat intercommunal?</h3>
      <div class="mb-3">
         <RadioBtn disabled={disabledFields} key="hasSyncidate" type="yes" title="Oui" value="1" checked="{$myStore.data.step2.pactIsSignedBySyndicate}" group="step2.pactIsSignedBySyndicate"></RadioBtn>
         <RadioBtn  disabled={disabledFields} key="hasSyncidate" type="no" title="Non" value="0" checked="{!$myStore.data.step2.pactIsSignedBySyndicate}" group="step2.pactIsSignedBySyndicate"></RadioBtn>
      </div>


   </div>

   <div class="section no-border">

      {#if $myStore.data.step2.pactIsSignedBySyndicate}
      <h3 class="title">Si oui, veuillez indiquer le nom du syndicat intercommunal</h3>
      <div class=" mb-3 custom-col-6 syndicate-name">
         <input class="" type="text" name="step2.syndicateName" placeholder="Nom du syndicat"/>

      </div>

      {/if}
   </div>

   <div class=" section no-border">


      <h3 class="title">Annexes à fournir</h3>

      <CommunityDataBox disabled={disabledFields}></CommunityDataBox>

   </div>
   {#if submitted && !validStep}
      <ErrorBox>Les champs avec un cadre rouge ne sont pas encore remplis ou sont erronés.</ErrorBox>
   {/if}
   {#if !submitted || !validStep}
      <div class="step-validation-btn">
         <button disabled={disabledFields} class="mt-2 btn btn-brand submitBtn" on:click={validateCurrentStep}>continuer</button>
      </div>
   {/if}
</div>


<style lang="scss">

   .syndicate-name{
      background:$secondary-color;
      padding:1.5em;
      border-radius: 9px;
      input{
         width:100%;
      }
   }

</style>
